import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import HeroStack from "@/pages/lp/HeroStack";

export const Route = createFileRoute("/lp/hero-stack/")({
  head: () => seoHead("/lp/hero-stack"),
  component: HeroStack,
});
